import React, { useEffect, useState } from "react";
import {
  ORG_ID,
  PAGE_SIZE_500,
  USER_ID,
  USER_TRAININGS_TYPE_LMS_DASHBOARD,
} from "../../../../constant/constant";
import { Grid } from "@mui/material";
import {
  getFormatedDate,
  useInfiniteScroll,
  downloadPDF,
  downloadExcel,
} from "../../../../utils/helper";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { useLocation, useNavigate } from "react-router-dom";
import {
  COURSESDETAIL,
  LESSONDETAIL,
  REPORTS_ANALYTICS_LMS_DASHBOARD_ITEMS,
  TOOL_BOX_DETAIL,
} from "../../../../constant/routeContant";
import Loader from "../../../../library/common/Loader";
import Table from "../../../../library/custom/table/table";
import UserFilterList from "../../../admin/shared/UserFilterList ";
import FilterListIcon from "@mui/icons-material/FilterList";
import commonImages from "../../../../assets";
import { Popover } from "@mui/material";

const UserTrainings = (props) => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [page, setPage] = useState(1);
  const [sortColumn, setSortColumn] = useState();
  const [sortDirection, setSortDirection] = useState("asc");

  const [isAllDataLoaded, setIsAllDataLoaded] = useState(false);

  const tableRef = useInfiniteScroll(() => {
    if (!isAllDataLoaded) {
      fetchData(page + 1);
    }
  }, [page, isAllDataLoaded]);
  const [value, setValue] = useState(0);
  const [anchorElFilter, setAnchorElFilter] = React.useState(null);
  const openFilter = Boolean(anchorElFilter);
  const idFilter = openFilter ? "simple-popover" : undefined;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorElFilter(null);
  };
  const [trainingType, setTrainingType] = useState("");

  useEffect(() => {
    setData([]);
    setData1([]);
  }, []);

  function a11yProps(index, id) {
    return {
      id: `${id}`,
      "aria-controls": `${index}`,
    };
  }

  useEffect(() => {
    if (
      props?.getLmsCourseLessonSafetyCompeleted_Detail &&
      props?.page === "usersWithHighestCompletedTraining"
    ) {
      setData((prevData) => [
        ...prevData,
        ...props?.getLmsCourseLessonSafetyCompeleted_Detail,
      ]);
      if (
        props?.getLmsCourseLessonSafetyCompeleted_Detail?.length < PAGE_SIZE_500
      ) {
        setIsAllDataLoaded(true);
      }
    }
  }, [props?.getLmsCourseLessonSafetyCompeleted_Detail]);

  useEffect(() => {
    //usersWithMostIncompletedTraining
    if (
      props?.getLmsCourseLessonSafetyInCompeleted_Detail &&
      props?.page === "usersWithMostIncompletedTraining"
    ) {
      setData1((prevData) => [
        ...prevData,
        ...props?.getLmsCourseLessonSafetyInCompeleted_Detail,
      ]);
    }
  }, [props?.getLmsCourseLessonSafetyInCompeleted_Detail]);

  const fetchMoreData = async (pageNumber) => {
    const isHighestCompleted =
      props.page === "usersWithHighestCompletedTraining";
    const tab =
      props.page === "usersWithHighestCompletedTraining"
        ? "Complete"
        : "InComplete";
    const data = {
      pageNumber: pageNumber,
      pageSize: PAGE_SIZE_500,
      search: "",
      catIds: "",
      statusId: props?.page === "usersWithHighestCompletedTraining" ? 1 : 2,
      userId: props?.apiData?.userId,
      orgId: ORG_ID(),
      fromDate: getFormatedDate(props?.apiData?.startDate),
      toDate: getFormatedDate(props?.apiData?.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      groupId: props?.apiData?.groupId ?? 0,
      trainingType:
        Array.isArray(props?.typeselectdata) && props.typeselectdata.length > 0
          ? props.typeselectdata
          : trainingType,

      ...(isHighestCompleted ? { IsSendMail: false } : { isSendEmail: false }),
    };

    try {
      const response = await props?.getMoretDetails(data, tab);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const fetchData = async (pageNumber) => {
    setPage((prevPage) => {
      const newPage = pageNumber;
      fetchMoreData(newPage);
      return newPage;
    });
    fetchMoreData(pageNumber);
  };

  const handleSortCourse = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortDirection(newDirection);
    setSortColumn(column);
    const sortedData = [...data].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };
  const handleSortInComp = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortDirection(newDirection);
    setSortColumn(column);
    const sortedData = [...data1].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData1(sortedData);
  };
  const location = useLocation();

  const getBackStateForDetail = () => ({
    apiData: location?.state?.apiData,
    page: props?.page,
    typeselectdata: props?.typeselectdata ?? [],
  });

  const handleOnClickCourse = (id) => {
    props?.handleClear();
    navigate(COURSESDETAIL, {
      state: {
        courseId: id,
        userId: USER_ID(),
        isAdminCourse: false,
        fromReportAnalytics: true,
        courseDetailBackPath: REPORTS_ANALYTICS_LMS_DASHBOARD_ITEMS,
        ...getBackStateForDetail(),
      },
    });
  };
  const completedcolumns = [
    {
      id: `${
        props.page === "usersWithMostIncompletedTraining"
          ? "assignDate"
          : "completedOn"
      }`,
      label: `${
        props.page === "usersWithMostIncompletedTraining"
          ? "Assigned On"
          : "Completed On"
      }`,
      sortable: true,
      isSorted:
        sortColumn ===
        `${
          props.page === "usersWithMostIncompletedTraining"
            ? "assignDate"
            : "completedOn"
        }`,
      sortDirection,
    },
    {
      id: "type",
      label: `Training Type`,
      sortable: true,
      isSorted: sortColumn === "type",
      sortDirection,
    },
    {
      id: "name",
      label: `Training Name`,
      sortable: true,
      isSorted: sortColumn === "name",
      sortDirection,
    },

    {
      id: "userName",
      label: `${
        props.page === "usersWithMostIncompletedTraining" ? "Not " : ""
      }Completed By`,
      sortable: true,
      isSorted: sortColumn === "userName",
      sortDirection,
    },
    {
      id: "blank1",
      label: "",
    },
  ];

  const completedData = data?.map((comp, index) => (
    <tr className="row" key={index}>
      <td>{getFormatedDate(comp?.completedOn)}</td>
      <td>{comp?.type}</td>
      <td>{comp?.name}</td>
      <td>{props?.apiData?.completedBy}</td>
      <td>
        <ReportRowManipulte
          rows={comp}
          view
          viewOnClick={
            comp?.type === "Course"
              ? () => handleOnClickCourse(comp?.id)
              : comp?.type === "Lesson"
                ? () => handleOnClickLesson(comp?.id)
                : comp?.type === "SafetyMeeting"
                  ? () => handleOnCellClick(comp) // TODO
                  : ""
          }
          viewLabel={`View ${
            comp?.type === "Course"
              ? "Course"
              : comp?.type === "Lesson"
                ? "Lesson"
                : comp?.type === "SafetyMeeting"
                  ? "SafetyMeeting"
                  : ""
          }`}
        />
      </td>
    </tr>
  ));

  const handleOnClickLesson = (id) => {
    props?.handleClear();
    navigate(LESSONDETAIL, {
      state: {
        lessonId: id,
        userId: USER_ID(),
        isAdminCourse: false,
        fromReportAnalytics: true,
        route: REPORTS_ANALYTICS_LMS_DASHBOARD_ITEMS,
        routeText: "Back",
        ...getBackStateForDetail(),
      },
    });
  };
  // Incomplete==========================
  const inCompletedData = data1?.map((inComp, index) => (
    <tr className="row" key={index}>
      <td>{getFormatedDate(inComp?.assignedOn)}</td>
      <td>{inComp?.type}</td>
      <td>{inComp?.name}</td>
      <td>{props?.apiData?.completedBy}</td>
      <td>
        <ReportRowManipulte
          rows={inComp}
          view
          viewOnClick={
            inComp?.type === "Course"
              ? () => handleOnClickCourse(inComp?.id)
              : inComp?.type === "Lesson"
                ? () => handleOnClickLesson(inComp?.id)
                : inComp?.type === "SafetyMeeting"
                  ? () => handleIncOnCellClick(inComp)
                  : ""
          }
          viewLabel={`View ${
            inComp?.type === "Course"
              ? "Course"
              : inComp?.type === "Lesson"
                ? "Lesson"
                : inComp?.type === "SafetyMeeting"
                  ? "SafetyMeeting"
                  : ""
          }`}
        />
      </td>
    </tr>
  ));
  const handleIncOnCellClick = (params) => {
    props?.handleClear();
    navigate(TOOL_BOX_DETAIL, {
      state: {
        fieldId: false,
        toolboxTalkId: params?.toolboxTalkId,
        scheduleId: 0,
        tabvalue: 0,
        toolboxTalkVersionId: params?.toolboxTalkVersionId,
        isCurrentActiveContent: false,
        showDownloadBtn: true,
        safetyDetail: {},
        fromCompletedTab: true,
        fromAssignedTab: false,
        fromMyTraining: true,
        userName: params?.userName,
        iscompleted: false,
        instructorUserId:
          params?.assignInstructorsUsersParentId > 0
            ? params?.assignInstructorsUsersParentId
            : params?.id,
        courseDetailBackPath: REPORTS_ANALYTICS_LMS_DASHBOARD_ITEMS,
        ...getBackStateForDetail(),
      },
    });
  };
  const handleOnCellClick = (params) => {
    props?.handleClear();
    navigate(TOOL_BOX_DETAIL, {
      state: {
        safetyDetail: {},
        toolboxtalkuyserlist: true,
        toolboxTalkVersionId: params?.toolboxTalkVersionId,
        isCurrentActiveContent: false,
        toolboxTalkId: params?.toolboxTalkId,
        instructorUserId:
          params?.assignInstructorsUsersParentId > 0
            ? params?.assignInstructorsUsersParentId
            : params?.id,
        scheduleId: params?.scheduleId,
        fromMyTraining: true,
        fromCompletedTab: true,
        showDownloadBtn: true,
        fromAssignedTab: false,
        userName: props?.apiData?.completedBy,
        iscompleted: true,
        courseDetailBackPath: REPORTS_ANALYTICS_LMS_DASHBOARD_ITEMS,
        ...getBackStateForDetail(),
      },
    });
  };

  const lmsTypeOnChanges = (e) => {
    const { value } = e?.target;
    const filteredValues = value?.filter((item) => item !== null);
    const keysArray = filteredValues.map((item) => item?.key);

    props?.setTypeselectdata(keysArray);
    setPage(1);
    setTrainingType(e?.target?.value);
  };
  const handleApply = (e) => {
    const isHighestCompleted =
      props.page === "usersWithHighestCompletedTraining";
    setData([]);
    setData1([]);
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE_500,
      search: "",
      catIds: "",
      statusId: props.page === "usersWithHighestCompletedTraining" ? 1 : 2,
      userId: props?.apiData?.userId,
      orgId: ORG_ID(),
      fromDate: getFormatedDate(props.apiData.startDate),
      toDate: getFormatedDate(props.apiData.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      trainingType: props?.typeselectdata,
      groupId: props?.apiData?.groupId ?? 0,
      ...(isHighestCompleted ? { IsSendMail: false } : { isSendEmail: false }),
    };
    props.getMoretDetails(
      data,
      props.page === "usersWithHighestCompletedTraining"
        ? "Complete"
        : "InComplete",
    );

    handleCloseFilter();
  };
  const handleClear = (e) => {
    const isHighestCompleted =
      props.page === "usersWithHighestCompletedTraining";
    setData([]);
    setData1([]);
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE_500,
      search: "",
      catIds: "",
      statusId: props.page === "usersWithHighestCompletedTraining" ? 1 : 2,
      userId: props?.apiData?.userId,
      orgId: ORG_ID(),
      fromDate: getFormatedDate(props.apiData.startDate),
      toDate: getFormatedDate(props.apiData.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      groupId: props?.apiData?.groupId ?? 0,
      trainingType: "",
      ...(isHighestCompleted ? { IsSendMail: false } : { isSendEmail: false }),
    };
    props.getMoretDetails(
      data,
      props?.page === "usersWithHighestCompletedTraining"
        ? "Complete"
        : "InComplete",
    );
    setTrainingType("");
    handleCloseFilter();
    props?.setTypeselectdata([]);
  };
  const rowsPdfIncompleted = data1?.map((training) => [
    training?.assignedOn,
    training?.type,
    training?.name,
    props?.apiData?.completedBy,
  ]);
  const rowsPdfcompleted = data?.map((training) => [
    training?.completedOn,
    training?.type,
    training?.name,
    props?.apiData?.completedBy,
  ]);

  const downloadAllData = () => {
    const isHighestCompleted =
      props.page === "usersWithHighestCompletedTraining";
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE_500,
      search: "",
      catIds: "",
      statusId: props?.page === "usersWithHighestCompletedTraining" ? 1 : 2,
      userId: props?.apiData?.userId,
      orgId: ORG_ID(),
      fromDate: getFormatedDate(props?.apiData?.startDate),
      toDate: getFormatedDate(props?.apiData?.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      groupId: props?.apiData?.groupId ?? 0,
      trainingType: props?.typeselectdata ?? trainingType,
      ...(isHighestCompleted ? { IsSendMail: true } : { isSendEmail: true }),
    };
    props.getMoretDetails(
      data,
      props?.page === "usersWithHighestCompletedTraining"
        ? "Complete"
        : "InComplete",
    );
  };
  useEffect(() => {
    if (
      Array.isArray(props?.typeselectdata) &&
      props.typeselectdata.length > 0
    ) {
      const selected = USER_TRAININGS_TYPE_LMS_DASHBOARD.filter((opt) =>
        props.typeselectdata.includes(opt.key),
      );
      setTrainingType(selected);
    } else if (
      Array.isArray(props?.typeselectdata) &&
      props.typeselectdata.length === 0
    ) {
      setTrainingType("");
    }
  }, [props?.typeselectdata]);

  return (
    <>
      <Grid container>
        <Grid container lg={12}>
          <Grid lg={8} className="lowestparticipate-left">
            <div className="topHeaderDrill">
              <div className="topHeaderDrillLeft">
                <div className="title">{props?.apiData?.completedBy}</div>
              </div>

              <div className="filter_btn_lms">
                <button
                  aria-describedby={idFilter}
                  variant="contained"
                  type="button"
                  name="btn"
                  onClick={(e) => handleClickFilter(e)}
                >
                  <FilterListIcon id="icn" /> Filters
                </button>
                <UserFilterList
                  firstLabel="Training Type"
                  secondLabel="Product"
                  id={idFilter}
                  open={openFilter}
                  anchorEl={anchorElFilter}
                  handleClose={handleCloseFilter}
                  resetBtn={true}
                  isShow={true}
                  lmsTypeList={true}
                  USER_TRAININGS_TYPE_LMS_DASHBOARD={
                    USER_TRAININGS_TYPE_LMS_DASHBOARD
                  }
                  trainingType={trainingType}
                  lmsTypeOnChanges={lmsTypeOnChanges}
                  handleApply={handleApply}
                  handleClear={handleClear}
                />
              </div>
            </div>
          </Grid>
          <Grid lg={4} className="lowestparticipate-right">
            <div className="topHeaderDrill">
              <div className="topHeaderDrillRight">
                <div
                  className="downloadBox"
                  aria-describedby={id}
                  variant="contained"
                  onClick={handleClick}
                >
                  <div className="downloadIcon">
                    <img src={commonImages?.downloadWhite} alt="Download" />
                  </div>
                  <div className="downloadText">Download Data</div>
                </div>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <div className="downloadListBox">
                    <div className="downloadList">
                      <div className="downloads">
                        <div
                          className="downloadListIcon"
                          onClick={
                            props?.page === "usersWithHighestCompletedTraining"
                              ? () =>
                                  downloadPDF(
                                    rowsPdfcompleted,
                                    completedcolumns?.map((col) => col?.label),
                                    "completed_training.pdf",
                                  )
                              : () =>
                                  downloadPDF(
                                    rowsPdfIncompleted,
                                    completedcolumns?.map((col) => col?.label),
                                    "incompleted_training.pdf",
                                  )
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M5.5 8.5H6.5V7H7C7.28333 7 7.52083 6.90417 7.7125 6.7125C7.90417 6.52083 8 6.28333 8 6V5.5C8 5.21667 7.90417 4.97917 7.7125 4.7875C7.52083 4.59583 7.28333 4.5 7 4.5H5.5V8.5ZM6.5 6V5.5H7V6H6.5ZM8.5 8.5H10C10.2833 8.5 10.5208 8.40417 10.7125 8.2125C10.9042 8.02083 11 7.78333 11 7.5V5.5C11 5.21667 10.9042 4.97917 10.7125 4.7875C10.5208 4.59583 10.2833 4.5 10 4.5H8.5V8.5ZM9.5 7.5V5.5H10V7.5H9.5ZM11.5 8.5H12.5V7H13.5V6H12.5V5.5H13.5V4.5H11.5V8.5ZM4.5 13C4.0875 13 3.73438 12.8531 3.44062 12.5594C3.14687 12.2656 3 11.9125 3 11.5V1.5C3 1.0875 3.14687 0.734376 3.44062 0.440626C3.73438 0.146876 4.0875 0 4.5 0H14.5C14.9125 0 15.2656 0.146876 15.5594 0.440626C15.8531 0.734376 16 1.0875 16 1.5V11.5C16 11.9125 15.8531 12.2656 15.5594 12.5594C15.2656 12.8531 14.9125 13 14.5 13H4.5ZM1.5 16C1.0875 16 0.734375 15.8531 0.440625 15.5594C0.146875 15.2656 0 14.9125 0 14.5V3H1.5V14.5H13V16H1.5Z"
                              fill="none"
                            />
                          </svg>
                          <span>Download PDF</span>
                        </div>
                      </div>
                    </div>
                    <div className="downloadList">
                      <div className="downloads">
                        <div
                          className="downloadListIcon"
                          onClick={
                            props?.page === "usersWithHighestCompletedTraining"
                              ? () =>
                                  downloadExcel(data, "completed_training.xlsx")
                              : () =>
                                  downloadExcel(
                                    data1,
                                    "incompleted_training.xlsx",
                                  )
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_6635_4490)">
                              <path
                                d="M9.22 0.0100392L0.26 1.71004C0.10875 1.73879 0 1.87629 0 2.03004V13.97C0 14.1238 0.10875 14.2613 0.26 14.29L9.22 15.99C9.24 15.9938 9.26 16 9.28 16C9.35375 16 9.4225 15.9775 9.48 15.93C9.55375 15.8688 9.6 15.775 9.6 15.68V0.320039C9.6 0.225039 9.55375 0.131289 9.48 0.0700392C9.40625 0.0087892 9.31375 -0.00746081 9.22 0.0100392ZM10.24 1.92004V4.16004H10.88V4.80004H10.24V6.40004H10.88V7.04004H10.24V8.64004H10.88V9.28004H10.24V11.2H10.88V11.84H10.24V14.08H15.04C15.3925 14.08 15.68 13.7925 15.68 13.44V2.56004C15.68 2.20754 15.3925 1.92004 15.04 1.92004H10.24ZM11.52 4.16004H14.08V4.80004H11.52V4.16004ZM2.14 5.02004H3.78L4.64 6.81004C4.7075 6.95129 4.7675 7.12504 4.82 7.32004H4.83C4.86375 7.20379 4.92875 7.02129 5.02 6.79004L5.97 5.02004H7.47L5.68 7.98004L7.52 11H5.93L4.89 9.05004C4.85125 8.97754 4.81125 8.84379 4.77 8.65004H4.76C4.74 8.74129 4.6925 8.88379 4.62 9.07004L3.58 11H1.98L3.89 8.01004L2.14 5.02004ZM11.52 6.40004H14.08V7.04004H11.52V6.40004ZM11.52 8.64004H14.08V9.28004H11.52V8.64004ZM11.52 11.2H14.08V11.84H11.52V11.2Z"
                                fill="none"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_6635_4490">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <span>Download.xlsx</span>
                        </div>
                      </div>
                    </div>
                    <div className="downloadList">
                      <div className="downloads">
                        <div
                          className="downloadListIcon"
                          onClick={downloadAllData}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M2 13.5V11H3.5V13.5H12.5V11H14V13.5C14 13.9125 13.8531 14.2656 13.5594 14.5594C13.2656 14.8531 12.9125 15 12.5 15H3.5C3.0875 15 2.73438 14.8531 2.44062 14.5594C2.14687 14.2656 2 13.9125 2 13.5ZM8 11.5L4 7.5L5.05 6.4L7.25 8.6V1H8.75V8.6L10.95 6.4L12 7.5L8 11.5Z"
                              fill="none"
                            />
                          </svg>
                          <span>Download All Data (Email)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Popover>
              </div>
            </div>
          </Grid>{" "}
        </Grid>
        {props?.userTRainingLoadin ? (
          <Loader />
        ) : (
          <Grid item md={12} mt={2}>
            <div className="customTableWrapper">
              {props?.page === "usersWithHighestCompletedTraining" && (
                <Table
                  columns={completedcolumns}
                  rows={completedData}
                  tableRef={tableRef}
                  onSort={handleSortCourse}
                />
              )}

              {props?.page === "usersWithMostIncompletedTraining" && (
                <Table
                  columns={completedcolumns}
                  rows={inCompletedData}
                  tableRef={tableRef}
                  onSort={handleSortInComp}
                />
              )}
            </div>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default UserTrainings;
